import { useMemo } from "react"
import WithToolTip from "../WithToolTip"
import { TrustScore } from "src/assets/icons"
import { roundOff } from "src/utils/helperFunctions"
import { getTraitBand } from "src/pages/OnePagerReport/oprations"
import styles from "./styles.module.scss"

const ProfessionalReadinessPill = ({ professionalReadiness, className = "" }) => {
    const pillData = useMemo(() => {
        if (!professionalReadiness) return null
        const overallScore = Number(professionalReadiness.overallScore ?? 0)
        const bandStyle = getTraitBand({ median: 50, lb: 25, ub: 75, score: overallScore * 10 })
        return { color: bandStyle.textColor, bg: bandStyle.color, score: overallScore }
    }, [professionalReadiness])

    const tooltipContent = useMemo(() => {
        const pr = professionalReadiness
        if (!pr || !pillData) return null
        return <div>
            <p className="text-white text-13 weight-700 mb-4">Professional Readiness</p>
            <div style={{ borderTop: '1px solid rgba(255,255,255,0.3)' }} className="mb-8" />
            <p className="text-white text-13 weight-700 mb-2">Overall Score: {pillData.score}</p>
            {pr.summary && <p className="text-white text-12 weight-400 mb-6">{pr.summary}</p>}
            <p className="text-white text-12 mb-1"><span className="weight-700">Facial Expressions: {roundOff(Number(pr.facialExpressions?.averageScore))}</span>{pr.facialExpressions?.summary ? ` (${pr.facialExpressions.summary})` : ""}</p>
            <p className="text-white text-12 mb-1"><span className="weight-700">Eye Contact: {roundOff(Number(pr.eyeContact?.averageScore))}</span>{pr.eyeContact?.summary ? ` (${pr.eyeContact.summary})` : ""}</p>
            <p className="text-white text-12 mb-1"><span className="weight-700">Grooming: {roundOff(Number(pr.grooming?.averageScore))}</span>{pr.grooming?.summary ? ` (${pr.grooming.summary})` : ""}</p>
            {pr.professionalConduct && <p className="text-white text-12"><span className="weight-700">Professional Conduct: {roundOff(Number(pr.professionalConduct?.averageScore))}</span>{pr.professionalConduct?.summary ? ` (${pr.professionalConduct.summary})` : ""}</p>}
        </div>
    }, [professionalReadiness, pillData])

    if (!pillData) return null

    return (
        <WithToolTip title={tooltipContent} showToolTip={!!tooltipContent}>
            <div
                className={`${styles.pill} pl-2 pr-8 py-2 b-20 flex items-center text-12 select-none ${className}`}
                style={{ background: "#F3F3F3", borderRight: "none" }}
            >
                <span style={{ background: pillData.bg }} className="px-8 py-4 mr-4 b-40">
                    <TrustScore color={pillData.color} />
                </span>
                <p style={{ color: pillData.color }}>Professional Readiness: {roundOff(pillData.score, 1)}</p>
            </div>
        </WithToolTip>
    )
}

export default ProfessionalReadinessPill
